import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LocationModal from "../LocationModal";
import {
  AuthContextProvider,
  LoaderContext,
} from "../../AuthContext/AuthContext";
import ConfirmationModal from "../ConfirmationModal";
import shoppingCart from "../../assets/images/shopping-cart.png";
import LoginPopUp from "../LoginPopup";
import mainLogo from "../../../src/assets/images/new/newLogo.jpg";
import shoppingBag from "../../../src/assets/images/new/shopping-bag.png";
import logoutProfile from "../../../src/assets/images/new/logoutProfile.png";
import wallet from "../../../src/assets/images/new/wallet.png";
import userProfile from "../../../src/assets/images/new/userProfile.png";
import referralIcon from "../../../src/assets/images/new/referralIcon.png";
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import axios from "axios";
import { ProductDetailsBySlug } from "../../ApiServices/EStore/EStoreApi";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { Prasad_CartList } from "../../ApiServices/Prasad/PrasadApi";
import { Tooltip } from "@mui/material";
import { langID } from "../enum";
import MobileNavbar from "./MobileNavbar";
import googlePlay from '../../assets/images/new/google-play.png'
import { GetProductCartList } from "../../ApiServices/EStore/EStoreApi";
import { PujaDetailsBySlug, GetPujaListBySearch } from '../../ApiServices/Puja/PujaApi';
import { GetTempleDetailsBySlugList } from "../../ApiServices/Temple/TempleApi";

const Navbar = () => {
  const userKeyID = localStorage.getItem("userKeyID")
  const searchRef = useRef(null);
  const [userCity, setUserCity] = useState(localStorage.getItem("userCity"));
  const [showModal, setShowModal] = useState(false);

  const { isAuthenticated } = useContext(AuthContextProvider);
  const {
    setLoader,
    loader,
    isLocationUpdate,
    setIsLocationUpdate,
    setIsCartUpdate,
    isCartUpdate,
    setPujaStatus,
    pujaStatus, setSelectedLanguageID, selectedLanguageID, setIsLanguageUpdate
  } = useContext(LoaderContext);
  const [confirmationModal, setConfirmationModal] = useState(null);
  const [onGetOTP, setOnGetOTP] = useState(null);
  const [showLoginPopUp, setShowLoginPopUp] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [itemCount, setItemCount] = useState(0);
  const [PrasadCount, setPrasadCount] = useState(0);
  const [ProductCount, setProductCount] = useState(0);
  const [login, setLogin] = useState(localStorage.getItem("userID"));
  const name = localStorage.getItem("name");
  const isActive = (path) => location.pathname === path;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const count = localStorage.getItem("cartItemCount");
  const prasadCount = localStorage.getItem("PrasadcartCount");
  const [moduleName, setModuleName] = useState("");
  const [open, setOpen] = useState(false);
  const menuRef = useRef();
  const dropdownRef = useRef();
  const [servicesDropdownOpen, setServicesDropdownOpen] = useState(false);
  const [pujaServicesDropdownOpen, setPujaServicesDropdownOpen] = useState(false);
  const [sankalpPujaServicesDropdownOpen, setSankalpPujaServicesDropdownOpen] = useState(false);
  const [darshanServicesDropdownOpen, setDarshanServicesDropdownOpen] = useState(false);
  const [templeServicesDropdownOpen, setTempleServicesDropdownOpen] = useState(false);
  const [astrologyServicesDropdownOpen, setAstrologyServicesDropdownOpen] = useState(false);
  const [panditServicesDropdownOpen, setPanditServicesDropdownOpen] = useState(false);
  const [chadhavaServicesDropdownOpen, setChadhavaServicesDropdownOpen] = useState(false);
  const [isServiceMenuOpen, setIsServiceMenuOpen] = useState(false);
  const { t } = useTranslation();
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [pujaSearchResults, setPujaSearchResults] = useState([]);
  const [isShowNewNavbar, setIsShowNavbar] = useState(true)

  const handleLogOut = () => {
    const city = localStorage.getItem("userCity"); // Get before clearing
    setConfirmationModal(false);
    localStorage.clear(); // Clears everything
    if (city) {
      localStorage.setItem("userCity", city); // Restore city
    }
    navigate("/");
    window.location.reload();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isSearchOpen &&
        searchRef.current &&
        !searchRef.current.contains(event.target)
      ) {
        setIsSearchOpen(false);
        setSearchText("");
        setPujaSearchResults([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSearchOpen]);


  useEffect(() => {
    setShowLoginPopUp(false);
  }, [onGetOTP]);

  useEffect(() => {

    if (isCartUpdate) {
      if (isAuthenticated) {
        GetProductCartListData()
      }
      setIsCartUpdate(false)
    }

  }, [isCartUpdate, isAuthenticated]);

  useEffect(() => {
    const searchPuja = async () => {
      if (searchText?.trim().length > 0) {
        await GetPujaListBySearchData();
      } else {
        setPujaSearchResults([]);
      }
    };

    searchPuja();
  }, [searchText]);







  useEffect(() => {
    if (isLocationUpdate) {
      const currentLocation = localStorage.getItem("userCity");
      setSelectedLocation(currentLocation);
      setUserCity(currentLocation);
      setIsLocationUpdate(false);
    }
    if (isAuthenticated) {
      GetProductCartListData()
    }

  }, [isLocationUpdate, isCartUpdate, isAuthenticated]);




  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        dropdownRef.current &&
        !menuRef.current.contains(event.target) &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const GetProductCartListData = async () => {

    setLoader(true);
    try {
      const response = await GetProductCartList(null, userKeyID);

      if (response?.statusCode === 200) {
        const data = response?.responseData?.data
        setLoader(false);
        setItemCount(data?.prasadCount + data?.productCount)


      } else {
        setLoader(false);

      }


    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  const GetPujaListBySearchData = async () => {
    if (!searchText?.trim()) {
      setPujaSearchResults([]);
      return;
    }

    try {
      const response = await GetPujaListBySearch(searchText.trim(), selectedLanguageID);

      if (response?.statusCode === 200) {
        const data = response?.responseData?.data || [];

        // Show only first 5 records
        setPujaSearchResults(data);
      } else {
        setPujaSearchResults([]);
      }
    } catch (error) {
      console.log(error);
      setPujaSearchResults([]);
    }
  };

  const handlePujaSearchSelect = async (slug, serviceType) => {
    if (!slug || !serviceType) return;

    setLoader(true);

    try {
      let response;

      // =========================
      // PUJA
      // =========================
      if (serviceType === "Puja") {
        response = await PujaDetailsBySlug({
          pujaSlug: slug,
          applangID: selectedLanguageID,
        });

        if (response?.statusCode !== 200) {
          console.warn("Puja details not found");
          return;
        }

        const canonicalTag =
          response?.responseData?.data?.canonicalTag;

        if (!canonicalTag) {
          console.log("Canonical tag not found");
          return;
        }

        const url = new URL(canonicalTag);
        const path = `${url.pathname}${url.search}${url.hash}`;

        console.log("Service Type:", serviceType);
        console.log("Slug:", slug);
        console.log("Canonical URL:", canonicalTag);
        console.log("Navigate Path:", path);

        // Close search
        setIsSearchOpen(false);
        setSearchText("");
        setPujaSearchResults([]);

        navigate(path);
      }

      // =========================
      // TEMPLE
      // =========================
      else if (serviceType === "Temple") {
        response = await GetTempleDetailsBySlugList(
          slug,
          selectedLanguageID
        );

        if (response?.statusCode !== 200) {
          console.warn("Temple details not found");
          return;
        }

        const temple = response?.responseData?.data?.[0];

        console.log("Service Type:", serviceType);
        console.log("Temple Details:", temple);

        // If API response contains canonicalTag

        const canonicalTag = temple?.canonicalTag;

        if (canonicalTag) {

          const url = new URL(canonicalTag);
          const path = `${url.pathname}${url.search}${url.hash}`;

          setIsSearchOpen(false);
          setSearchText("");
          setPujaSearchResults([]);

          navigate(path);
        }
      }

      // =========================
      // PRODUCT
      // =========================
      else if (serviceType === "Product") {
        response = await ProductDetailsBySlug({
          productSlug: slug,
          applangID: selectedLanguageID,
          userKeyID: userKeyID,
        });

        if (response?.statusCode !== 200) {
          console.warn("Product details not found");
          return;
        }

        const product = response?.responseData?.data;

        console.log("Service Type:", serviceType);
        console.log("Product Details:", product);

        // If API response contains canonicalTag
        const canonicalTag = product?.canonicalTag;

        if (canonicalTag) {
          const url = new URL(canonicalTag);
          const path = `${url.pathname}${url.search}${url.hash}`;

          setIsSearchOpen(false);
          setSearchText("");
          setPujaSearchResults([]);

          navigate(path);
        }
      }

      // =========================
      // UNKNOWN SERVICE TYPE
      // =========================
      else {
        console.warn("Unknown service type:", serviceType);
      }

    } catch (error) {
      console.error(
        `Error fetching ${serviceType} details:`,
        error
      );
    } finally {
      setLoader(false);
    }
  };

  // const handlePujaSearchSelect = async (slug) => {
  //   if (!slug) return;

  //   setLoader(true);

  //   try {
  //     const response = await PujaDetailsBySlug({
  //       pujaSlug: slug,
  //       applangID: selectedLanguageID,
  //     });

  //     if (response?.statusCode !== 200) {
  //       return;
  //     }

  //     const canonicalTag =
  //       response?.responseData?.data?.canonicalTag;

  //     if (!canonicalTag) {
  //       console.log("Canonical tag not found");
  //       return;
  //     }


  //     const url = new URL(canonicalTag);

  //     const path = `${url.pathname}${url.search}${url.hash}`;

  //     console.log("Puja Slug:", slug);
  //     console.log("Canonical URL:", canonicalTag);
  //     console.log("Navigate Path:", path);


  //     setIsSearchOpen(false);
  //     setSearchText("");
  //     setPujaSearchResults([]);


  //     navigate(path);

  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setLoader(false);
  //   }
  // };



  const handleSelectCity = (city) => {
    if (city) {
      localStorage.setItem("userCity", city);
      setUserCity(city);
      setIsLocationUpdate(true);
      setShowModal(false);
    }
  };
  const ChangeLocation = () => {
    setShowModal(true);
  }

  const toggleMenu = () => {
    setOpen(!open);
  };


  const changeLanguage = (e) => {

    const selectedLang = e.target.value;
    if (selectedLang === "en") {
      setSelectedLanguageID(langID?.English)
      localStorage.setItem("selectedLangID", langID?.English);
      setIsLanguageUpdate(true);
    } else if (selectedLang === "mi") {
      setSelectedLanguageID(langID?.Marathi)
      localStorage.setItem("selectedLangID", langID?.Marathi);
      setIsLanguageUpdate(true);
    } else if (selectedLang === "hi") {
      setSelectedLanguageID(langID?.Hindi)
      localStorage.setItem("selectedLangID", langID?.Hindi);
      setIsLanguageUpdate(true);
    }

    i18n.changeLanguage(selectedLang);
  };

  const handleAstrologyClicked = () => {

    if (!isAuthenticated) {
      setShowLoginPopUp(true);
    } else {
      navigate('/horoscope-detail');
    }

  }


  const oldNavbar = () => {
    return (
      <>
        <div
          //  className="topbar-two"

          //  className="main-header main-header--four sticky-header sticky-header--normal"
          className="main-header main-header--four sticky-header sticky-header--normal"
          style={{
            position: "fixed",
            width: "100%",

            zIndex: 1000,
            backgroundColor: "#a42642",

            boxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
            WebkitBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
            MozBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
          }}
        >
          <div className="container" style={{ maxWidth: '1300px' }}>
            <div
              className="topbar-two__inner"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <ul className="topbar-two__info">

                <li
                  style={{ color: "white" }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                >
                  <span className="topbar-two__info__icon">
                    <i className="icofont-envelope"></i>
                  </span>
                  <a
                    style={{ color: "white" }}
                    onMouseEnter={(e) => (e.target.style.color = "white")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    href="mailto:info@myomnamo.com"
                  >
                    info@myomnamo.com
                  </a>
                </li>
                {selectedLocation !== null &&
                  selectedLocation !== undefined &&
                  selectedLocation !== "" ? (
                  <li style={{ color: "white" }}>
                    <span className="topbar-two__info__icon">
                      <i className="icofont-location-pin"></i>
                    </span>
                    <span style={{ cursor: 'pointer' }} onClick={ChangeLocation}>{t(selectedLocation)}</span>
                  </li>
                ) : (
                  ""
                )}
              </ul>
              <ul className="langSelector">

                <select
                  onChange={changeLanguage}
                  value={i18n.language}
                  style={{
                    padding: '0px 5px',
                    borderRadius: '6px',
                    border: '1px solid #ccc',
                    cursor: 'pointer'
                  }}
                >
                  <option value="en">English</option>
                  <option value="mi">मराठी</option>
                </select>


              </ul>
              {isAuthenticated ? (
                <ul className="list-unstyled topbar-two__nav">


                  <li
                    className="nav-list"
                    style={{ display: 'flex', height: '30px' }}
                  // onMouseEnter={(e) => (e.target.style.color = "white")}
                  // onMouseLeave={(e) => (e.target.style.color = "white")}

                  >
                    <div className="profile-menu-wrapper" ref={menuRef} style={{ position: "relative" }}>
                      <div
                        className="profile-icon"
                        onClick={toggleMenu}
                        style={{
                          width: "29px",
                          height: "29px",
                          borderRadius: "50%",
                          backgroundColor: "#fff",
                          color: "#a42642",
                          display: "flex",
                          alignItems: "center",
                          marginTop: '4px',
                          justifyContent: "center",
                          cursor: "pointer",

                        }}
                      >
                        <i className="fa fa-user"></i>
                      </div>


                    </div>
                  </li>
                  {/* <li
                  className="nav-list"
                  style={{ color: "white" }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                >
                  <i class="fa-solid fa-right-from-bracket"></i>{" "}
                  <Link
                    style={{ color: "white" }}
                    onMouseEnter={(e) => (e.target.style.color = "white")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    onClick={() => setConfirmationModal(true)}
                  >
                    {t("Logout")}
                  </Link>
                </li> */}
                </ul>
              ) : (
                <ul className="list-unstyled topbar-two__nav">
                  {/* <li
                  className="nav-list"
                  style={{ color: "white" }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                >
                  <Link
                    style={{ color: "white" }}
                    onMouseEnter={(e) => (e.target.style.color = "white")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    to="/login"
                  >
                    Login / Sign Up
                  </Link>
                </li> */}
                  {/* <li
                  style={{ color: "white" }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                >
                  <Link
                    style={{ color: "white" }}
                    onMouseEnter={(e) => (e.target.style.color = "white")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    to="/register"
                  >
                    Register
                  </Link>
                </li> */}
                </ul>
              )}
            </div>
          </div>
        </div >
        {/* Top mobile bar - visible only on mobile */}
        <div
          className="mobile-top-bar"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px 16px",
            // backgroundColor: "#a52444",
            borderBottom: "1px solid #eee",
            // position: "sticky",
            top: 0,
            // zIndex: 2000,

            position: "fixed",
            width: "100%",

            zIndex: 1000,
            backgroundColor: "#a42642",

            boxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
            WebkitBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
            MozBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
          }
          }
        >
          <span style={{ fontSize: "14px", color: "#555" }}>
            {selectedLocation !== null &&
              selectedLocation !== undefined &&
              selectedLocation !== "" ? (

              <li style={{ color: "white", listStyle: "none" }}>
                <span className="topbar-two__info__icon">
                  <i className="icofont-location-pin"></i>
                </span>
                <span style={{ cursor: 'pointer' }} onClick={ChangeLocation}>{selectedLocation}</span>
              </li>
            ) : (
              ""
            )}
          </span>

          {
            isAuthenticated ? (
              <>

                <div className="profile-menu-wrapper" ref={menuRef} style={{ position: "relative" }}>
                  <div
                    className="profile-icon"
                    onClick={toggleMenu}
                    style={{
                      width: "27px",
                      height: "23px",
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      color: "#a42642",
                      display: "flex",
                      marginTop: '4px',
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                    }}
                  >
                    <i className="fa fa-user"></i>
                  </div>

                  {open && (
                    <div style={{ position: 'absolute', zIndex: 1 }}>
                      {/* Trigger */}
                // <button onClick={() => setOpen(!open)}>Profile</button>

                      {/* Dropdown */}
                      {open && (
                        ReactDOM.createPortal(
                          <ul
                            ref={dropdownRef}
                            className="profile-dropdown"
                            style={{
                              position: "fixed",
                              top: "40px",
                              right: 0,
                              backgroundColor: "#fff",
                              borderRadius: "8px",
                              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                              listStyle: "none",
                              padding: "10px",
                              width: "171px",
                              zIndex: 999999,
                            }}
                          >
                            <li style={{ marginBottom: "8px" }}>
                              <Link
                                className="ProfileIcons"
                                to="/my-profile"
                                onClick={() => {
                                  setTimeout(() => setOpen(false), 500); // allow Link to work
                                }}

                              >
                                {/* <i class="fa-regular fa-user  " style={{ margin: '0px 5px' }}></i> */}
                                <img src={userProfile} width={20} height={20} className="ProfileIcons"></img>
                                {t("My Profile")}
                              </Link>

                            </li>
                            <li style={{ marginBottom: "8px" }}>
                              <Link
                                to="/wallet"
                                className="ProfileIcons"

                                onClick={() => {
                                  setTimeout(() => setOpen(false), 0); // allow Link to work
                                }} >
                                {/* <i class="fa-solid fa-wallet ProfileIcons" style={{ margin: '0px 5px' }} ></i> */}
                                <img src={wallet} width={20} height={20} className="ProfileIcons"></img>
                                {t("My Wallet")}</Link>
                            </li>
                            <li style={{ marginBottom: "8px" }}>
                              <Link
                                className="ProfileIcons"

                                to="/my-orders"
                                onClick={() => {
                                  setTimeout(() => setOpen(false), 0); // allow Link to work
                                }}
                              >
                                {/* <i
                            class="fa-solid fa-bag-shopping"
                            style={{ margin: '0px 5px' }}
                          ></i>{" "} */}
                                <img src={shoppingBag} width={20} height={20} className="ProfileIcons"></img>
                                {t("My Order")}
                              </Link>
                            </li>
                            <li style={{ marginBottom: "8px" }}>
                              <Link
                                className="ProfileIcons"
                                to="/refer-and-earn"
                                onClick={() => {
                                  setTimeout(() => setOpen(false), 500); // allow Link to work
                                }}

                              >
                                {/* <i class="fa-regular fa-user  " style={{ margin: '0px 5px' }}></i> */}
                                <img src={userProfile} width={20} height={20} className="ProfileIcons"></img>
                                {t("My Referrals")}
                              </Link>

                            </li>
                            <li>
                              <span
                                className="ProfileIcons"

                                onClick={() => {
                                  setOpen(false);

                                  setConfirmationModal(true);
                                }}
                                style={{ cursor: "pointer", textDecoration: 'none' }}
                              >
                                {/* <i class="fa-solid fa-right-from-bracket ProfileIcons" style={{ margin: '0px 5px' }}></i> */}
                                <img src={logoutProfile} width={20} height={20} className="ProfileIcons"></img>
                                {t("Logout")}
                              </span>
                            </li>
                          </ul>,
                          document.body
                        )
                      )}
                    </div>

                  )}
                </div>
              </>

            ) : (
              <button
                onClick={() => setShowLoginPopUp(true)}
                style={{
                  fontSize: "14px",
                  color: "white",
                  fontWeight: "bold",
                  border: "none",
                  background: "none",

                }}
              >
                Login
              </button>
            )
          }
        </div >

        <header
          className="main-header main-header--four sticky-header sticky-header--normal"
          style={{
            position: "fixed",
            top: "35px",
            left: 0,
            width: "100%",
            zIndex: 1000,
            backgroundColor: "#fff",
            boxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
            WebkitBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
            MozBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
          }}
        >

          <div className="container-fluid" style={{ maxWidth: '1200px' }}>
            <div className="main-header__inner">
              <div className="main-header__logo">
                <Link to="/">
                  <img src={mainLogo} height="80px" width="223px" alt="Logo" />
                </Link>
              </div>

              <nav className="main-header__nav main-menu">
                <ul className="main-menu__list">
                  <li>
                    <Link
                      to="/"
                      style={{ color: isActive("/") ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                    >
                      {t('Home')}

                    </Link>
                  </li>
                  {/* <li>
                  <Link
                    to="/about-us"
                    style={{
                      color: isActive("/about-us") ? "#d09d18" : "black",
                    }}
                  >
                    About Us
                  </Link>
                </li> */}
                  <li>
                    {/* Dropdown trigger */}
                    <Link
                      to="#"
                      className="how-we-help-hover"
                      onClick={(e) => {
                        e.preventDefault();
                        setServicesDropdownOpen(!servicesDropdownOpen);
                      }}
                      style={{
                        color: isActive("#") ? "#d09d18" : "black",
                        gap: "5px",
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center', textWrap: 'nowrap'
                      }}
                    >
                      {t('Our Services')}

                      <i
                        className="fas fa-chevron-down"
                        style={{ fontSize: "12px", marginLeft: "5px" }}
                      ></i>
                    </Link>

                    {/* Conditional dropdown */}
                    {servicesDropdownOpen && (
                      <ul>
                        <li>
                          <Link
                            to="/services/puja-booking"

                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Offline Puja Booking')}
                            {/* Offline Puja Booking */}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/services/online-puja-services"

                            onClick={() => {
                              setPujaStatus(true);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Online Puja Booking')}
                            {/* Online Puja Booking */}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/services/daily-puja-booking"

                            onClick={() => setServicesDropdownOpen(false)}
                          >
                            {t('Daily Puja Booking')}
                            {/* Daily Puja Booking */}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/services/e-store"

                            onClick={() => setServicesDropdownOpen(false)}
                          >
                            {t('E-Store')}
                            {/* E-Store */}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/services/darshan-booking"

                            onClick={() => setServicesDropdownOpen(false)}
                          >
                            {t('Darshan Booking')}
                            {/* Darshan Booking */}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/services/temple-puja"

                            onClick={() => setServicesDropdownOpen(false)}
                          >
                            {t('Puja At Temple')}
                            {/* Puja At Temple */}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/services/online-prasad-booking"

                            onClick={() => setServicesDropdownOpen(false)}
                          >
                            {t('Prasad Booking')}
                            {/* Prasad Booking */}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/services/horoscope"

                            onClick={() => setServicesDropdownOpen(false)}
                          >
                            {t('Horoscope')}
                            {/* Horoscope */}
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/services/puja-kit-services"

                            onClick={() => setServicesDropdownOpen(false)}
                          >
                            {t('Bhakti Puja Kit')}
                            {/* Bhakti Puja Kit */}
                          </Link>
                        </li>
                        {/* <li>
                        <Link
                          to="/ganesh-visarjan"

                          onClick={() => setServicesDropdownOpen(false)}
                        >
                          {t('Ganpati Visarjan')}

                        </Link>
                      </li> */}
                      </ul>
                    )}
                  </li>

                  <li>
                    <Link
                      to="/temples"
                      style={{
                        color: isActive("/temples") ? "#d09d18" : "black",
                        textDecoration: 'none'
                      }}
                    >
                      {t('Temples')}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/spiritual-gyan"
                      style={{
                        color: isActive("/spiritual-gyan") ? "#d09d18" : "black",
                        textDecoration: 'none', textWrap: 'nowrap'
                      }}
                    >
                      {t('Spiritual Gyan')}

                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/contact-us"
                      style={{
                        color: isActive("/contact-us") ? "#d09d18" : "black",
                        textDecoration: 'none', textWrap: 'nowrap'
                      }}
                    >
                      {t('Contact Us')}

                    </Link>
                  </li>
                </ul>
              </nav>
              <Link
                to="/view-cart"
                state={{
                  moduleName: moduleName,
                }}
                className="main-header__cart position-relative "

              >
                {isAuthenticated ? (
                  <div style={{ position: "relative", display: "inline-block", cursor: "pointer" }}>
                    <img src={shoppingCart} width={30} height={30} alt="Cart" />
                    {itemCount > 0 && (
                      <span
                        style={{
                          position: "absolute",
                          top: "-5px",
                          right: "-5px",
                          background: "#8f3246",
                          borderRadius: "50%", // Ensure full round shape
                          width: "20px", // Fixed width
                          height: "20px", // Fixed height
                          display: "flex", // Center the text
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "white",
                        }}
                        className="cart-badge"
                      >
                        {itemCount}
                      </span>
                    )}
                  </div>
                ) : (
                  <Link onClick={() => setShowLoginPopUp(true)}>
                    <span className="login-signup-nav" >Login</span>
                  </Link>
                  // <Link onClick={() => navigate("/login")}>
                  //   <span className="login-signup-nav">Login/signup</span>
                  // </Link>
                )}
              </Link>
              <div className="main-header__right">
                {/* Mobile Nav Toggle Button */}
                <div className="d-flex justify-content-between d-sm-none d-md-none " style={{ width: '5em' }}>
                  <div className="mobile-nav__btn ">

                    <div onClick={() => {
                      setIsMobileMenuOpen((prev) => !prev)
                      navigate('/view-cart', {
                        state: {
                          moduleName: moduleName,
                        },
                      })
                    }
                    } style={{ position: "relative", display: "inline-block", left: '15px', bottom: '7px', cursor: "pointer" }}>
                      <img src={shoppingCart} width={30} height={30} alt="Cart" />
                      {itemCount > 0 && (
                        <span
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",

                            background: "#8f3246",
                            borderRadius: "50%", // Ensure full round shape
                            width: "20px", // Fixed width
                            height: "20px", // Fixed height
                            display: "flex", // Center the text
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "white",
                          }}
                          className="cart-badge"
                        >
                          {itemCount}
                        </span>
                      )}
                    </div>
                  </div>
                  <div
                    className="mobile-nav__btn mobile-nav__toggler" style={{ color: "#ffa415" }}
                    onClick={() => setIsMobileMenuOpen((prev) => !prev)}
                  >

                    <i
                      className={`fas ${isMobileMenuOpen ? "fa-times" : "fa-bars"}`}
                    ></i>
                  </div>
                </div>


                {/* Mobile Nav Menu (show when open) */}
                {isMobileMenuOpen && (
                  <div
                    className="mobile-menu shadow-lg"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      width: "100%",
                      backgroundColor: "#fff",
                      zIndex: 9999,
                      borderBottomLeftRadius: "12px",
                      borderBottomRightRadius: "12px",
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                      height: '20em',
                      overflowY: 'auto'
                    }}
                  >
                    <ul className="list-unstyled m-0 p-3">
                      <li className="mb-2">
                        <Link
                          to="/"
                          className="d-block  text-decoration-none py-2 px-3 rounded hover-bg"
                          onClick={() => {
                            setIsServiceMenuOpen(false)
                            setIsMobileMenuOpen(false)
                          }}
                          style={{ color: isActive("/") ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                        >
                          Home
                        </Link>
                      </li>

                      {/* Our Services dropdown */}
                      <li className="mb-2">
                        <div
                          className="d-flex justify-content-between align-items-center text-dark text-decoration-none py-2 px-3 rounded hover-bg fw-bold"
                          onClick={() => setIsServiceMenuOpen(!isServiceMenuOpen)}
                          style={{ cursor: "pointer" }}
                        >
                          <span>Our Services</span>
                          <span>{isServiceMenuOpen ? "−" : "+"}</span> {/* Toggle Icon */}
                        </div>

                        {isServiceMenuOpen && (
                          <ul className="list-unstyled ps-3">
                            {[
                              { path: "/services/puja-booking", label: "Puja Booking" },
                              { path: "/services/online-puja-services", label: "Online Puja Booking" },
                              { path: "/services/daily-puja-booking", label: "Daily Puja Booking" },
                              { path: "/services/e-store", label: "E-Store" },
                              { path: "/services/darshan-booking", label: "Darshan Booking" },
                              { path: "/services/temple-puja", label: "Puja At Temple" },
                              { path: "/services/online-prasad-booking", label: "Prasad Booking" },
                              { path: "/services/horoscope", label: "Horoscope" },
                              { path: "/services/puja-kit-services", label: "Bhakti Puja Kit" },
                            ].map((subItem, index) => (
                              <li key={index} className="mb-1">
                                <Link
                                  to={subItem.path}
                                  className="d-block  text-decoration-none py-1 px-3 rounded hover-bg"
                                  onClick={() => {
                                    if (subItem?.path === "/services/online-puja-services") {
                                      setPujaStatus(true);

                                    }
                                    setIsMobileMenuOpen(false)
                                    setIsServiceMenuOpen(false)
                                  }}
                                  style={{ color: isActive(subItem.path) ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                                >
                                  {subItem.label}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                      <li className="mb-2">
                        <Link
                          to="/temples"
                          className="d-block  text-decoration-none py-2 px-3 rounded hover-bg"
                          onClick={() => {
                            setIsServiceMenuOpen(false)
                            setIsMobileMenuOpen(false)
                          }}
                          style={{ color: isActive("/temples") ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                        >
                          Temples
                        </Link>
                      </li>

                      {/* Other Items */}
                      <li className="mb-2">
                        <Link
                          to="/spiritual-gyan"
                          className="d-block  text-decoration-none py-2 px-3 rounded hover-bg"
                          onClick={() => {
                            setIsServiceMenuOpen(false)
                            setIsMobileMenuOpen(false)
                          }}
                          style={{ color: isActive("/spiritual-gyan") ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                        >
                          Spiritual Gyan
                        </Link>
                      </li>

                      <li className="mb-2">
                        <Link
                          to="/contact-us"
                          className="d-block  text-decoration-none py-2 px-3 rounded hover-bg"
                          onClick={() => {
                            setIsServiceMenuOpen(false)
                            setIsMobileMenuOpen(false)
                          }}
                          style={{ color: isActive("/contact-us") ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                        >
                          Contact Us
                        </Link>
                      </li>
                      {/* <li>
                      <Link
                        to="/ganesh-visarjan"
                        style={{ color: isActive("/ganesh-visarjan") ? "#d09d18" : "black", textDecoration: 'none', textWrap: 'nowrap' }}
                      >
                        {t('Ganpati Visarjan')}

                      </Link>
                    </li> */}
                      {/* Login/{t("Logout")} */}
                      <li className="mt-3 border-top pt-3">
                        {isAuthenticated ? (
                          <Link
                            className="d-block text-danger fw-semibold text-decoration-none py-2 px-3 rounded hover-bg"
                            onClick={() => setConfirmationModal(true)}
                          >
                            {t("Logout")}
                          </Link>
                        ) : (
                          <Link
                            className="d-block text-danger fw-semibold text-decoration-none py-2 px-3 rounded hover-bg"
                            onClick={() => setShowLoginPopUp(true)}
                          >
                            Login
                          </Link>
                        )}
                      </li>
                    </ul>

                  </div>
                )}


                {/* <Link target="__blank" className="careox-btn"> */}
                <a
                  className="download-app-btn"
                  href="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span style={{ fontFamily: "Bricolage Grotesque", textWrap: 'nowrap' }}>
                    {t("Download App")} &nbsp;
                    <i className="icofont-download"></i>
                  </span>
                </a>

                {/* </Link> */}
              </div>
            </div>
          </div >
        </header >
      </>
    )
  }

  const newNavbar = () => {
    return (
      <>
        <div
          //  className="topbar-two"

          //  className="main-header main-header--four sticky-header sticky-header--normal"
          className="main-header main-header--four sticky-header sticky-header--normal"
          style={{
            position: "fixed",
            width: "100%",

            zIndex: 1000,
            backgroundColor: "#a42642",

            boxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
            WebkitBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
            MozBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
          }}
        >
          <div className="container" >
            <div
              className="topbar-two__inner"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <ul className="topbar-two__info">

                <li
                  className="mobile-view-email"
                  style={{ color: "white" }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                >
                  <span className="topbar-two__info__icon mobile-view-email ">
                    <i className="icofont-envelope"></i>
                  </span>
                  <a
                    className="mobile-view-email"
                    style={{ color: "white" }}
                    onMouseEnter={(e) => (e.target.style.color = "white")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    href="mailto:info@myomnamo.com"
                  >
                    info@myomnamo.com
                  </a>
                </li>
                {userCity !== null &&
                  userCity !== undefined &&
                  userCity !== "" ? (
                  <li style={{ color: "white" }}>
                    <span className="topbar-two__info__icon">
                      <i className="icofont-location-pin"></i>
                    </span>
                    <span style={{ cursor: 'pointer' }} onClick={ChangeLocation}>{t(userCity)}</span>
                  </li>
                ) : (
                  ""
                )}
              </ul>
              <div className="d-flex justify-content-end">
                <ul className="langSelector">

                  <select
                    onChange={changeLanguage}
                    value={i18n.language}
                    style={{
                      padding: '0px 5px',
                      borderRadius: '6px',
                      border: '1px solid #ccc',
                      cursor: 'pointer'
                    }}
                  >
                    <option value="en">English</option>
                    <option value="mi">मराठी</option>
                    <option value="hi">हिन्दी</option>
                  </select>


                </ul>
                {isAuthenticated ? (
                  <ul className="list-unstyled topbar-two__nav">


                    <li
                      className="nav-list mobile-userstyle"
                      style={{ display: 'flex', height: '30px' }}
                    // onMouseEnter={(e) => (e.target.style.color = "white")}
                    // onMouseLeave={(e) => (e.target.style.color = "white")}

                    >
                      <div className="profile-menu-wrapper" ref={menuRef} style={{ position: "relative" }}>
                        <div
                          className="profile-icon"
                          onClick={toggleMenu}
                          style={{
                            width: "27px",
                            height: "23px",
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                            color: "#a42642",
                            display: "flex",
                            marginTop: '4px',
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          <i className="fa fa-user"></i>
                        </div>


                      </div>
                    </li>
                    {/* <li
                  className="nav-list"
                  style={{ color: "white" }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                >
                  <i class="fa-solid fa-right-from-bracket"></i>{" "}
                  <Link
                    style={{ color: "white" }}
                    onMouseEnter={(e) => (e.target.style.color = "white")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    onClick={() => setConfirmationModal(true)}
                  >
                    {t("Logout")}
                  </Link>
                </li> */}
                  </ul>
                ) : (
                  <ul className="list-unstyled topbar-two__nav">
                    {/* <li
                  className="nav-list"
                  style={{ color: "white" }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                >
                  <Link
                    style={{ color: "white" }}
                    onMouseEnter={(e) => (e.target.style.color = "white")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    to="/login"
                  >
                    Login / Sign Up
                  </Link>
                </li> */}
                    {/* <li
                  style={{ color: "white" }}
                  onMouseEnter={(e) => (e.target.style.color = "white")}
                  onMouseLeave={(e) => (e.target.style.color = "white")}
                >
                  <Link
                    style={{ color: "white" }}
                    onMouseEnter={(e) => (e.target.style.color = "white")}
                    onMouseLeave={(e) => (e.target.style.color = "white")}
                    to="/register"
                  >
                    Register
                  </Link>
                </li> */}
                  </ul>
                )}
              </div>

            </div>
          </div>
        </div >
        {/* Top mobile bar - visible only on mobile */}
        <div
          className="mobile-top-bar d-flex align-items-center justify-content-between d-block d-md-none"
          style={{
            padding: "2px px",
            position: "fixed",
            top: 29,
            width: "100%",
            zIndex: 1000,
            backgroundColor: "#a42642",
            borderBottom: "1px solid #eee",
            boxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
          }}
        >
          {/* ---------- LEFT : Location ---------- */}
          {userCity && (
            <div className="d-flex align-items-center" style={{ color: "white" }}>
              <i className="icofont-location-pin me-1"></i>
              <span className="mobile-top" style={{ cursor: "pointer" }} onClick={ChangeLocation}>
                {userCity}
              </span>
            </div>
          )}

          {/* ---------- RIGHT : Language + Profile ---------- */}
          <div className="d-flex align-items-center gap-2">
            {isAuthenticated ? (
              <>
                {/* Language selector */}
                <select
                  onChange={changeLanguage}
                  value={i18n.language}
                  style={{
                    padding: "2px 6px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    cursor: 'pointer'
                  }}
                >
                  <option value="en">English</option>
                  <option value="mi">मराठी</option>
                  <option value="hi">हिन्दी</option>
                </select>

                {/* Profile icon & dropdown */}
                <div
                  className="position-relative"
                  ref={menuRef}
                >
                  <div
                    className="profile-icon d-flex align-items-center justify-content-center"
                    onClick={toggleMenu}
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      color: "#000",
                      cursor: "pointer",
                    }}
                  >
                    <i className="fa fa-user"></i>
                  </div>

                  {open &&
                    ReactDOM.createPortal(
                      <ul
                        ref={dropdownRef}
                        className="profile-dropdown user-menu-dropdown"

                      >
                        <li style={{ marginBottom: "8px" }}>
                          <Link
                            className="ProfileIcons"
                            to="/my-profile"
                            onClick={() => {
                              setTimeout(() => setOpen(false), 500); // allow Link to work
                            }}

                          >
                            {/* <i class="fa-regular fa-user  " style={{ margin: '0px 5px' }}></i> */}
                            <img src={userProfile} width={20} height={20} className="ProfileIcons"></img>
                            {t("My Profile")}
                          </Link>

                        </li>
                        <li style={{ marginBottom: "8px" }}>
                          <Link
                            to="/wallet"
                            className="ProfileIcons"

                            onClick={() => {
                              setTimeout(() => setOpen(false), 0); // allow Link to work
                            }} >
                            {/* <i class="fa-solid fa-wallet ProfileIcons" style={{ margin: '0px 5px' }} ></i> */}
                            <img src={wallet} width={20} height={20} className="ProfileIcons"></img>
                            {t("My Wallet")}</Link>
                        </li>
                        <li style={{ marginBottom: "8px" }}>
                          <Link
                            className="ProfileIcons"

                            to="/my-orders"
                            onClick={() => {
                              setTimeout(() => setOpen(false), 0); // allow Link to work
                            }}
                          >
                            {/* <i
                            class="fa-solid fa-bag-shopping"
                            style={{ margin: '0px 5px' }}
                          ></i>{" "} */}
                            <img src={shoppingBag} width={20} height={20} className="ProfileIcons"></img>
                            {t("My Order")}
                          </Link>
                        </li>
                        <li style={{ marginBottom: "8px" }}>
                          <Link
                            className="ProfileIcons"
                            to="/refer-and-earn"
                            onClick={() => {
                              setTimeout(() => setOpen(false), 500); // allow Link to work
                            }}

                          >
                            {/* <i class="fa-regular fa-user  " style={{ margin: '0px 5px' }}></i> */}
                            <img src={userProfile} width={20} height={20} className="ProfileIcons"></img>
                            {t("My Referrals")}
                          </Link>

                        </li>
                        <li>
                          <span
                            className="ProfileIcons"

                            onClick={() => {
                              setOpen(false);

                              setConfirmationModal(true);
                            }}
                            style={{ cursor: "pointer", textDecoration: 'none' }}
                          >
                            {/* <i class="fa-solid fa-right-from-bracket ProfileIcons" style={{ margin: '0px 5px' }}></i> */}
                            <img src={logoutProfile} width={20} height={20} className="ProfileIcons"></img>
                            {t("Logout")}
                          </span>
                        </li>
                      </ul>,
                      document.body
                    )}
                </div>
              </>
            ) : (
              <button
                onClick={() => setShowLoginPopUp(true)}
                style={{
                  fontSize: "14px",
                  color: "white",
                  fontWeight: "bold",
                  border: "none",
                  background: "none",
                }}
              >
                {t("Login")}
              </button>
            )}
          </div>
        </div>


        <header
          className="main-header main-header--four sticky-header sticky-header--normal"
          style={{
            position: "fixed",
            top: "35px",
            left: 0,
            width: "100%",
            zIndex: 1000,
            backgroundColor: "#fff",
            boxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
            WebkitBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
            MozBoxShadow: "0px 10px 5px -5px rgba(0,0,0,0.2)",
          }}
        >

          <div className="container-fluid" style={{ maxWidth: '1200px' }}>
            <div className="main-header__inner">
              <div className="main-header__logo">
                <Link to="/">
                  <img src={mainLogo} height="80px" width="223px" alt="Logo" />
                </Link>
              </div>

              <nav className="main-header__nav main-menu">
                <ul className="main-menu__list">

                  {/* Home */}
                  {/* <li>
                    <Link
                      to="/"
                      style={{
                        color: isActive("/") ? "#d09d18" : "black",
                        textDecoration: 'none', textWrap: 'nowrap'
                      }}
                    >
                      {t('Home')}

                    </Link>
                  </li> */}


                  {/*Pujas Dropdown trigger */}
                  <li>

                    <Link
                      to="#"
                      className="how-we-help-hover "

                      onClick={(e) => {
                        e.preventDefault();
                        setServicesDropdownOpen(!servicesDropdownOpen);
                      }}
                      style={{
                        color: isActive("/remedy-puja") || isActive("/homam-puja") ? "#d09d18" : "black",
                        gap: "5px",
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center', textWrap: 'nowrap'
                      }}
                    >
                      {t('Pujas')}

                      <i
                        className="fas fa-chevron-down"
                        style={{ fontSize: "12px", marginLeft: "5px" }}
                      ></i>
                    </Link>

                    {/* Conditional dropdown */}
                    {servicesDropdownOpen && (
                      <ul
                        style={{
                          position: "absolute",
                          zIndex: 11000,
                        }}>
                        <li>
                          <Link
                            to="/remedy-puja"
                            className={`${isActive("/remedy-puja") ? 'selected-item' : ''}`}
                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Remedy Puja')}

                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/homam-puja"
                            className={`${isActive("/homam-puja") ? 'selected-item' : ''}`}
                            onClick={() => {
                              setPujaStatus(true);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Homam')}

                          </Link>
                        </li>

                      </ul>
                    )}
                  </li>

                  {/*Pandit Dropdown trigger */}
                  <li>

                    <Link
                      to="#"
                      className="how-we-help-hover"
                      onClick={(e) => {
                        e.preventDefault();
                        setPanditServicesDropdownOpen(!panditServicesDropdownOpen);
                      }}
                      style={{
                        color: isActive("/pandit-puja") || isActive("/daily-pandit-puja") ? "#d09d18" : "black",
                        gap: "5px",
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center', textWrap: 'nowrap'
                      }}
                    >
                      {t('Pandit')}

                      <i
                        className="fas fa-chevron-down"
                        style={{ fontSize: "12px", marginLeft: "5px" }}
                      ></i>
                    </Link>


                    {panditServicesDropdownOpen && (
                      <ul
                        style={{
                          position: "absolute",
                          zIndex: 11000,
                        }}>
                        <li>
                          <Link
                            to="/pandit-puja"
                            className={`${isActive("/pandit-puja") ? 'selected-item' : ''}`}

                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Pandit Booking')}

                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/daily-pandit-puja"
                            className={`${isActive("/daily-pandit-puja") ? 'selected-item' : ''}`}
                            onClick={() => {
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Daily Pandit (Puja)')}

                          </Link>
                        </li>




                      </ul>
                    )}
                  </li>




                  {/*Sankalp Puja Dropdown trigger */}
                  <li>

                    <Link
                      to="#"
                      className="how-we-help-hover"
                      onClick={(e) => {
                        e.preventDefault();
                        setSankalpPujaServicesDropdownOpen(!sankalpPujaServicesDropdownOpen);
                      }}
                      style={{
                        color: isActive("/remedy-subscription-puja") || isActive("/homam-subscription-puja") ? "#d09d18" : "black",
                        gap: "5px",
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center', textWrap: 'nowrap',

                      }}
                    >
                      {t('Sankalp Puja')}

                      <i
                        className="fas fa-chevron-down"
                        style={{ fontSize: "12px", marginLeft: "5px" }}
                      ></i>
                    </Link>


                    {sankalpPujaServicesDropdownOpen && (
                      <ul
                        style={{
                          position: "absolute",
                          zIndex: 11000,
                        }}>
                        <li>
                          <Link
                            to="/remedy-subscription-puja"

                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Subscription Remedy Pujas')}

                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/homam-subscription-puja"

                            onClick={() => {
                              setPujaStatus(true);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Subscription Homam Pujas')}

                          </Link>
                        </li>

                      </ul>
                    )}
                  </li>

                  {/*Darshan Dropdown trigger */}
                  {/* <li>

                    <Link
                      to="#"
                      className="how-we-help-hover"
                      onClick={(e) => {
                        e.preventDefault();
                        setDarshanServicesDropdownOpen(!darshanServicesDropdownOpen);
                      }}
                      style={{
                        color: isActive("#") ? "#d09d18" : "black",
                        gap: "5px",
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center', textWrap: 'nowrap'
                      }}
                    >
                      {t('Darshan')}

                      <i
                        className="fas fa-chevron-down"
                        style={{ fontSize: "12px", marginLeft: "5px" }}
                      ></i>
                    </Link>


                    {darshanServicesDropdownOpen && (
                      <ul>
                        <li>
                          <Link
                            to="/services/puja-booking"

                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Daily Darshan')}

                          </Link>
                        </li>


                      </ul>
                    )}
                  </li> */}

                  {/* E-store */}
                  <li>
                    <Link
                      to="/services/e-store"
                      style={{
                        color: isActive("/services/e-store") ? "#d09d18" : "black",
                        textDecoration: 'none', textWrap: 'nowrap'
                      }}
                    >
                      {t('E-Store')}

                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/temples"
                      style={{
                        color: isActive("/temples") ? "#d09d18" : "black",
                        textDecoration: 'none', textWrap: 'nowrap'
                      }}
                      onClick={() => {
                        setPujaStatus(false);
                        setServicesDropdownOpen(false);
                      }}
                    >
                      {t('Temples')}

                    </Link>
                  </li>

                  {/* Astrology */}
                  <li onClick={handleAstrologyClicked}>
                    <Link

                      style={{
                        color: isActive("/horoscope-detail") ? "#d09d18" : "black",
                        textDecoration: 'none', textWrap: 'nowrap'
                      }}
                    >
                      {t('Astrology')}

                    </Link>
                  </li>

                  {/* <li>
                    <Link
                      to="/spiritual-gyan"
                      style={{
                        color: isActive("/spiritual-gyan") ? "#d09d18" : "black",
                        textDecoration: 'none', textWrap: 'nowrap'
                      }}
                    >
                      {t('Spiritual Gyan')}

                    </Link>
                  </li> */}


                  {/*Astrology Dropdown trigger */}
                  {/* <li>

                    <Link
                      to="#"
                      className="how-we-help-hover"
                      onClick={(e) => {
                        e.preventDefault();
                        setAstrologyServicesDropdownOpen(!astrologyServicesDropdownOpen);
                      }}
                      style={{
                        color: isActive("#") ? "#d09d18" : "black",
                        gap: "5px",
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center', textWrap: 'nowrap'
                      }}
                    >
                      {t('Astrology')}

                      <i
                        className="fas fa-chevron-down"
                        style={{ fontSize: "12px", marginLeft: "5px" }}
                      ></i>
                    </Link>


                    {astrologyServicesDropdownOpen && (
                      <ul>
                        <li>
                          <Link
                            to="/services/horoscope"
                            style={{
                              color: isActive("/services/horoscope") ? "#d09d18" : "",

                            }}
                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Horoscope')}

                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/basic-details"
                            style={{
                              color: isActive("/basic-details") ? "#d09d18" : "",

                            }}
                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Basic Astology')}

                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/numerology"
                            style={{
                              color: isActive("/numerology") ? "#d09d18" : "",

                            }}
                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Numerology')}

                          </Link>
                        </li>

                        <li>
                          <Link
                            to="/daily-panchang"
                            style={{
                              color: isActive("/daily-panchang") ? "#d09d18" : "",

                            }}
                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Panchang')}

                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/Prediction"
                            style={{
                              color: isActive("/Prediction") ? "#d09d18" : "",

                            }}
                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Prediction')}

                          </Link>
                        </li>


                        <li>
                          <Link
                            to="#"

                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Corporate Numerology')}

                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"

                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Vidhi Booking')}

                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"

                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Zodiac')}

                          </Link>
                        </li>

                        <li>
                          <Link
                            to="#"

                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Prasannam')}

                          </Link>
                        </li>


                      </ul>
                    )}
                  </li> */}



                  {/*Chadhava Dropdown trigger */}
                  {/* <li>

                    <Link
                      to="#"
                      className="how-we-help-hover"
                      onClick={(e) => {
                        e.preventDefault();
                        setChadhavaServicesDropdownOpen(!chadhavaServicesDropdownOpen);
                      }}
                      style={{
                        color: isActive("#") ? "#d09d18" : "black",
                        gap: "5px",
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center', textWrap: 'nowrap'
                      }}
                    >
                      {t('Chadhava')}

                      <i
                        className="fas fa-chevron-down"
                        style={{ fontSize: "12px", marginLeft: "5px" }}
                      ></i>
                    </Link>


                    {chadhavaServicesDropdownOpen && (
                      <ul>
                        <li>
                          <Link
                            to="#"

                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Go Seva')}

                          </Link>
                        </li>

                        <li>
                          <Link
                            to="#"

                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Brahmin Bhog')}

                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"

                            onClick={() => {
                              setPujaStatus(false);
                              setServicesDropdownOpen(false);
                            }}
                          >
                            {t('Temple Chadhava')}

                          </Link>
                        </li>


                      </ul>
                    )}
                  </li> */}


                  {!isAuthenticated && (
                    <li>
                      <Link onClick={() => setShowLoginPopUp(true)}>
                        <span className="login-signup-nav" >{t("Login")}</span>
                      </Link>
                    </li>
                  )}


                </ul>

              </nav>



              {/* Mobile View */}
              <div className="main-header__right">
                {/* Mobile Nav Toggle Button */}

                {/* Search Icon */}
                <div
                  className="d-sm-none d-md-none"
                  onClick={() => { setSearchText(""); setIsSearchOpen((prev) => !prev) }}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "12px",
                    color: "#a42642",
                    fontSize: "22px",
                  }}
                >
                  <i className="fas fa-search"></i>
                </div>

                <div
                  className="d-none d-sm-block"
                  onClick={() => { setSearchText(""); setIsSearchOpen((prev) => !prev) }}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "22px",
                    color: "#a42642",
                    fontSize: "22px",
                  }}
                >
                  <i className="fas fa-search"></i>
                </div>


                <div className="d-flex justify-content-between d-sm-none d-md-none " style={{ width: '5em' }}>
                  <div className="mobile-nav__btn ">

                    <div onClick={() => {

                      navigate('/view-cart', {
                        state: {
                          moduleName: moduleName,
                        },
                      })
                    }
                    } style={{ position: "relative", display: "inline-block", left: '15px', bottom: '7px', cursor: "pointer" }}>
                      <img src={shoppingCart} width={30} height={30} alt="Cart" />
                      {itemCount > 0 && (
                        <span
                          style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",

                            background: "#8f3246",
                            borderRadius: "50%", // Ensure full round shape
                            width: "20px", // Fixed width
                            height: "20px", // Fixed height
                            display: "flex", // Center the text
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "12px",
                            fontWeight: "bold",
                            color: "white",
                          }}
                          className="cart-badge"
                        >
                          {itemCount}
                        </span>
                      )}
                    </div>
                  </div>
                  <div
                    className="mobile-nav__btn mobile-nav__toggler " style={{ color: "#ffa415" }}
                    onClick={() => setIsMobileMenuOpen((prev) => !prev)}
                  >

                    <i
                      className={`fas ${isMobileMenuOpen ? "fa-times" : "fa-bars"}`}
                    ></i>
                  </div>
                </div>




                {isAuthenticated && (
                  <div className="d-none d-sm-block" onClick={() => {


                    navigate('/view-cart', {
                      state: {
                        moduleName: moduleName,
                      },
                    })
                  }
                  } style={{ position: "relative", display: "inline-block", left: '-15px', bottom: '4px', cursor: "pointer" }}>
                    <img src={shoppingCart} width={30} height={30} alt="Cart" />
                    {itemCount > 0 && (
                      <span
                        style={{
                          position: "absolute",
                          top: "-15px",
                          right: "-4px",

                          background: "#8f3246",
                          borderRadius: "50%", // Ensure full round shape
                          width: "20px", // Fixed width
                          height: "20px", // Fixed height
                          display: "flex", // Center the text
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: "white",
                        }}
                        className="cart-badge"
                      >
                        {itemCount}
                      </span>
                    )}
                  </div>
                )}


                {/* <Link target="__blank" className="careox-btn"> */}
                <Tooltip title={t("Download Our App")}>
                  <a
                    className="download-app-btn"
                    href="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo"
                    target="_blank"
                    rel="noopener noreferrer"

                  >
                    <span style={{ fontFamily: "Bricolage Grotesque", fontSize: "16px", textWrap: 'nowrap' }}>
                      {t("Download App")} &nbsp;
                      <i className="icofont-download"></i>
                    </span>
                  </a>


                  {/* <a
                    className="download-app-btn"
                    href="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo"
                    target="_blank"
                    rel="noopener noreferrer"

                  >



                    <span style={{ fontFamily: "Bricolage Grotesque", }}>

                      <img src={googlePlay} width={30} height={30}></img><br />

                    </span>
                  </a> */}
                </Tooltip>



              </div>
            </div>
            {/* Search Bar */}
            {isSearchOpen && (
              <div
                // style={{
                //   width: "100%",
                //   padding: "12px 20px",
                // }}
                ref={searchRef}
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  zIndex: 999,
                  padding: "10px 20px",
                }}
              >
                <div
                  style={{
                    maxWidth: "640px",
                    margin: "0 auto",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {/* Search Icon - Left */}
                  <i
                    className="fas fa-search"
                    style={{
                      position: "absolute",
                      left: "18px",
                      color: "#a42642",
                      fontSize: "18px",
                      zIndex: 999,
                    }}
                  ></i>

                  {/* Search Input */}
                  <input
                    type="text"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder={t("Search...")}
                    autoFocus
                    style={{
                      width: "100%",
                      height: "45px",
                      border: "1px solid #ddd",
                      borderRadius: "25px",
                      padding: "0 50px",
                      outline: "none",
                      fontSize: "15px",
                    }}
                  />


                  {/* Close Icon - Right */}
                  <i
                    className="fas fa-times"
                    onClick={() => {
                      setIsSearchOpen(false);
                      setSearchText("");
                    }}
                    style={{
                      position: "absolute",
                      right: "18px",
                      color: "#a42642",
                      fontSize: "15px",
                      cursor: "pointer",
                    }}
                  ></i>
                </div>
                {pujaSearchResults.length > 0 && (
                  <div

                    style={{
                      position: "absolute",
                      top: "calc(100% + 1px)",
                      left: 20,
                      right: 20,
                      maxWidth: "640px",
                      margin: "0 auto",
                      zIndex: 999,
                      backgroundColor: "#fff",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.15)",
                      maxHeight: "250px",
                      overflowY: "auto",

                    }}
                  >
                    {pujaSearchResults.map((puja, index) => (
                      <div
                        key={puja.pujaKeyID || index}
                        onClick={() =>
                          handlePujaSearchSelect(puja.slug, puja.serviceType)
                        }
                        style={{
                          padding: "12px 18px",
                          cursor: "pointer",
                          borderBottom:
                            index !== pujaSearchResults.length - 1
                              ? "1px solid #eee"
                              : "none",
                          fontSize: "15px",
                          color: "#333",
                          transition: "background 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f8f1f3";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "#fff";
                        }}
                      >
                        {puja.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </header >
      </>
    )
  }
  return (
    <>
      {isShowNewNavbar ? newNavbar() : oldNavbar()}
      <ConfirmationModal
        show={confirmationModal}
        onHide={() => setConfirmationModal(false)}
        onConfirm={handleLogOut}
      />
      <LoginPopUp
        show={showLoginPopUp}
        onHide={() => setShowLoginPopUp(false)}
        setOnGetOTP={setOnGetOTP}
      />

      {
        showModal && (
          <LocationModal
            show={showModal}
            onHide={() => setShowModal(false)}
            onSelectCity={handleSelectCity}
          />
        )
      }
      <MobileNavbar
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}

        /* dropdown state + setters */
        servicesDropdownOpen={servicesDropdownOpen}
        setServicesDropdownOpen={setServicesDropdownOpen}

        sankalpPujaServicesDropdownOpen={sankalpPujaServicesDropdownOpen}
        setSankalpPujaServicesDropdownOpen={setSankalpPujaServicesDropdownOpen}

        darshanServicesDropdownOpen={darshanServicesDropdownOpen}
        setDarshanServicesDropdownOpen={setDarshanServicesDropdownOpen}

        templeServicesDropdownOpen={templeServicesDropdownOpen}
        setTempleServicesDropdownOpen={setTempleServicesDropdownOpen}

        astrologyServicesDropdownOpen={astrologyServicesDropdownOpen}
        setAstrologyServicesDropdownOpen={setAstrologyServicesDropdownOpen}

        panditServicesDropdownOpen={panditServicesDropdownOpen}
        setPanditServicesDropdownOpen={setPanditServicesDropdownOpen}

        chadhavaServicesDropdownOpen={chadhavaServicesDropdownOpen}
        setChadhavaServicesDropdownOpen={setChadhavaServicesDropdownOpen}

        /* auth + helpers you already have in parent */
        isAuthenticated={isAuthenticated}
        setConfirmationModal={setConfirmationModal}
        setShowLoginPopUp={setShowLoginPopUp}
        isActive={isActive}
        t={t}
      />

    </>
  );
};

export default Navbar;
